import React, { useState, useRef, useEffect, } from 'react';
import Banner from "../Banner/Banner";
import Nav1 from "../Nav1/Nav1";
import Nav2 from "../Nav2/Nav2";
import Products from "../Products/Products";
import { ModuleItemProps } from "@/types/interfaces";

interface ModuleProps {
  list: ModuleItemProps[];
}

const OtherModule: React.FC<ModuleProps> = (props) => {
  const { list } = props;
  const [isShow, setIsShow] = useState<boolean>(false)
  const otherModuleDom = useRef<HTMLDivElement>(null)

  const handleScroll = (e: any) => {
    const newScrollTop = e.target.scrollTop;
    if (!isShow && newScrollTop > 100) {
      setIsShow(true)
    }
  };

  useEffect(() => {
    if (document.querySelector('#J_homeBd') && props.list.length) {
      const scrollDom = document.querySelector('#J_homeBd') as HTMLElement
      scrollDom.addEventListener('scroll', handleScroll);
      return () => {
        scrollDom.removeEventListener('scroll', handleScroll);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.list]);

  const OtherModuleItem = () => {
    return list.map((item: ModuleItemProps) => {
      return (
        <div key={item.corpModuleId}>
          {item.type === 0 && <Banner module={item} />}
          {item.type === 1 && <Nav1 module={item} />}
          {item.type === 2 && <Nav2 module={item} />}
          {item.type === 3 && <Products module={item} />}
        </div>
      );
    });
  }

  return (
    <div className='other-module' ref={otherModuleDom}>
      { isShow && <OtherModuleItem /> }
    </div>
  )
}

export default OtherModule;